// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"style__highlighted__bkbwJ"};